import React, { useState } from 'react';

import WpButton from 'Wpds/components/button/WpButton';
import WpButtonGroup from 'Wpds/components/button/WpButtonGroup';
import { WpModal, WpModalHeader, WpModalBody, WpModalFooter } from 'Wpds/components/modal';
import { WpRadioGroup, WpRadioInput } from 'Wpds/components/radio';

type Props = {
  isOpen: boolean;
  onToggle: Function;
  onSaveClick: Function;
};

function UpdateScheduleModal({ isOpen, onToggle, onSaveClick }: Props) {
  const [applyToAll, setApplyToAll] = useState(false);
  const handleSaveClick = () => onSaveClick(applyToAll);
  return (
    <WpModal isOpen={isOpen} size="sm" onToggle={() => onToggle()} dismissOnBackdrop={false}>
      <WpModalHeader>Update schedule</WpModalHeader>
      <WpModalBody>
        <b>This section has a schedule applied to all topics.</b>
        <p />
        Do you want to change the schedule for <b>all topics</b> in this section or <b>just this topic</b>?
        <WpRadioGroup
          id="apply_to_all_topics_or_just_this_topic_input"
          label=""
          required
          defaultValue="apply_to_just_this_topic"
          onChange={value => setApplyToAll(value === 'apply_to_all_topics')}
        >
          <WpRadioInput
            id="apply_to_all_topics"
            label="Apply to all topics in this section"
            value="apply_to_all_topics"
          />
          <WpRadioInput id="apply_to_just_this_topic" label="Just this topic" value="apply_to_just_this_topic" />
        </WpRadioGroup>
      </WpModalBody>
      <WpModalFooter>
        <WpButtonGroup>
          <WpButton variant="tertiary" onClick={() => onToggle()}>
            Cancel
          </WpButton>
          <WpButton onClick={handleSaveClick}>Save</WpButton>
        </WpButtonGroup>
      </WpModalFooter>
    </WpModal>
  );
}

export default UpdateScheduleModal;
